import { Component } from '@angular/core';

@Component({
	selector: 'sd-footer',
	template: `
		<footer class="site-footer">
			<span
				>InMotion Labs |
				<a
					href="https://www.inmotionhosting.com/"
					target="_blank"
					rel="noreferrer"
					>InMotion Hosting</a
				></span
			>
			<nav aria-label="Legal">
				<a
					href="https://www.inmotionhosting.com/legal/universal-terms-of-service/?utm_source=direct&utm_medium=direct"
					target="_blank"
					rel="noreferrer"
					>Universal Terms of Service</a
				>
				<a
					href="https://www.inmotionhosting.com/legal/privacy-policy/?utm_source=direct&utm_medium=direct"
					target="_blank"
					rel="noreferrer"
					>Privacy Policy</a
				>
			</nav>
		</footer>
	`,
})
export class FooterComponent {}
